import { render, staticRenderFns } from "./sentenceM0.vue?vue&type=template&id=5aa14561&scoped=true&"
import script from "./sentenceM0.vue?vue&type=script&lang=js&"
export * from "./sentenceM0.vue?vue&type=script&lang=js&"
import style0 from "./sentenceM0.vue?vue&type=style&index=0&id=5aa14561&lang=scss&scoped=true&"
import style1 from "./sentenceM0.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5aa14561",
  null
  
)

export default component.exports